import React from 'react';
import PropTypes from 'prop-types';
import { FilterSection } from './filter_section';
import { FilterSelect } from './filters/filter_select';
import TranslationContainer from '../../../translation/translation_container';
import getTranslatedText from '../../../../helper/get_translated_text';
import { Filters } from '../../../../constants/filter/filters';
import {FilterLabelTranslationKeys} from "../../../../constants/filter/filter_label_translation_keys";
import Translation from '../../../translation/translation';

function TyreRatings(props) {
    const opened = props.opened
        || !!props.utqgTreadwearGroupValue || !!props.utqgTractionValue || !!props.utqgTemperatureValue
        || !!props.labelNoiseValue || !!props.labelWetGripValue || !!props.labelFuelEfficiencyValue;

    return (
        <FilterSection
            opened={opened}
            resettable={props.resettable}
            onActionClick={props.onActionClick}
            headline='catalog-filters-section-headline-tyre-ratings'
            containerModifier="tyre-ratings"
            extraHeight={true}
        >
            <div className="catalog-filter-section__group-name catalog-filter-section__group-name catalog-filter-section__group-name catalog-filter-section__group-name"><Translation translationKey="catalog-filter-group-label" /></div>
            <TranslationContainer
                targetProperties={{
                    tooltipContent: { translationKey: 'catalog-filter-label-noise-tooltip-text' },
                }}
            >
                <FilterSelect
                    name={Filters.LABEL_NOISE}
                    value={props.labelNoiseValue}
                    options={props.labelNoiseOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.LABEL_NOISE]}
                    provideAllTranslationKey="catalog-filters-label-noise-select-label-all"
                    onChange={props.onLabelNoiseChange}
                    onToolTipHover={() => props.onToolTipHover('Label Noise')}
                    provideAllOption={true}
                    tooltipContent="There should be some text here"
                    highlight={!props.labelNoiseValue}
                    unavailableOptions = {[]}
                />
            </TranslationContainer>

            <TranslationContainer
                targetProperties={{
                    tooltipContent: { translationKey: 'catalog-filter-label-wet-grip-tooltip-text' },
                }}
            >
                <FilterSelect
                    name={Filters.LABEL_WET_GRIP}
                    value={props.labelWetGripValue}
                    options={props.labelWetGripOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.LABEL_WET_GRIP]}
                    provideAllTranslationKey="catalog-filters-label-wet-grip-select-label-all"
                    onChange={props.onLabelWetGripChange}
                    onToolTipHover={() => props.onToolTipHover('Label Wet Grip')}
                    provideAllOption={true}
                    tooltipContent="There should be some text here"
                    highlight={!props.labelWetGripValue}
                    unavailableOptions = {[]}
                />
            </TranslationContainer>

            <TranslationContainer
                targetProperties={{
                    tooltipContent: { translationKey: 'catalog-filter-label-fuel-efficiency-tooltip-text' },
                }}
            >
                <FilterSelect
                    name={Filters.LABEL_FUEL_EFFICIENCY}
                    value={props.labelFuelEfficiencyValue}
                    options={props.labelFuelEfficiencyOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.LABEL_FUEL_EFFICIENCY]}
                    provideAllTranslationKey="catalog-filters-label-fuel-efficiency-select-label-all"
                    onChange={props.onLabelFuelEfficiencyChange}
                    onToolTipHover={() => props.onToolTipHover('Label Fuel Efficiency')}
                    provideAllOption={true}
                    tooltipContent="There should be some text here"
                    highlight={!props.labelFuelEfficiencyValue}
                    unavailableOptions = {[]}
                />
            </TranslationContainer>

            <div className="catalog-filter-section__group-name catalog-filter-section__group-name catalog-filter-section__group-name catalog-filter-section__group-name--following"><Translation translationKey="catalog-filter-group-utqg" /></div>
            <TranslationContainer
                targetProperties={{
                    tooltipContent: { translationKey: 'catalog-filter-utqg-treadwear-group-tooltip-text' },
                }}
            >
                <FilterSelect
                    name={Filters.UTQG_TREADWEAR_GROUP}
                    value={props.utqgTreadwearGroupValue}
                    options={props.utqgTreadwearGroupOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.UTQG_TREADWEAR_GROUP]}
                    provideAllTranslationKey="catalog-filters-utqg-treadwear-group-select-label-all"
                    onChange={props.onUtqgTreadwearGroupChange}
                    onToolTipHover={() => props.onToolTipHover('UTQG Treadwear')}
                    provideAllOption={true}
                    tooltipContent="There should be some text here"
                    highlight={!props.utqgTreadwearGroupValue}
                    unavailableOptions = {[]}
                />
            </TranslationContainer>

            <TranslationContainer
                targetProperties={{
                    tooltipContent: { translationKey: 'catalog-filter-utqg-traction-tooltip-text' },
                }}
            >
                <FilterSelect
                    name={Filters.UTQG_TRACTION}
                    value={props.utqgTractionValue}
                    options={props.utqgTractionOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.UTQG_TRACTION]}
                    provideAllTranslationKey="catalog-filters-utqg-traction-select-label-all"
                    onChange={props.onUtqgTractionChange}
                    onToolTipHover={() => props.onToolTipHover('UTQG Traction')}
                    provideAllOption={true}
                    tooltipContent="There should be some text here"
                    highlight={!props.utqgTractionValue}
                    unavailableOptions = {[]}
                    />
            </TranslationContainer>

            <TranslationContainer
                targetProperties={{
                    tooltipContent: { translationKey: 'catalog-filter-utqg-temperature-tooltip-text' },
                }}
            >
                <FilterSelect
                    name={Filters.UTQG_TEMPERATURE}
                    value={props.utqgTemperatureValue}
                    options={props.utqgTemperatureOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.UTQG_TEMPERATURE]}
                    provideAllTranslationKey="catalog-filters-utqg-temperature-select-label-all"
                    onChange={props.onUtqgTemperatureChange}
                    onToolTipHover={() => props.onToolTipHover('UTQG Temperature')}
                    provideAllOption={true}
                    tooltipContent="There should be some text here"
                    highlight={!props.utqgTemperatureValue}
                    unavailableOptions = {[]}
                    />
            </TranslationContainer>
        </FilterSection>
    );
}

TyreRatings.propTypes = {
    opened: PropTypes.bool.isRequired,
    resettable: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func.isRequired,
    onToolTipHover: PropTypes.func.isRequired,

    utqgTreadwearGroupValue: PropTypes.string.isRequired,
    utqgTractionValue: PropTypes.string.isRequired,
    utqgTemperatureValue: PropTypes.string.isRequired,
    labelNoiseValue: PropTypes.string.isRequired,
    labelWetGripValue: PropTypes.string.isRequired,
    labelFuelEfficiencyValue: PropTypes.string.isRequired,

    utqgTreadwearGroupOptions: PropTypes.array.isRequired,
    utqgTractionOptions: PropTypes.array.isRequired,
    utqgTemperatureOptions: PropTypes.array.isRequired,
    labelNoiseOptions: PropTypes.array.isRequired,
    labelWetGripOptions: PropTypes.array.isRequired,
    labelFuelEfficiencyOptions: PropTypes.array.isRequired,

    onUtqgTreadwearGroupChange: PropTypes.func.isRequired,
    onUtqgTractionChange: PropTypes.func.isRequired,
    onUtqgTemperatureChange: PropTypes.func.isRequired,
    onLabelNoiseChange: PropTypes.func.isRequired,
    onLabelWetGripChange: PropTypes.func.isRequired,
    onLabelFuelEfficiencyChange: PropTypes.func.isRequired,
};

export { TyreRatings };
